// import { BLUECONIC_SITES } from './BLUECONIC_SITES.const';

export const hasGoogleOAuth = (
  edition: string,
  propertyEndpoint?: string,
  experiments?: string[],
): boolean => {
  if (!propertyEndpoint) return false;

  const hasSuppressedExperiment = experiments?.some(experiment => experiment.includes('google-oauth') && experiment.includes('suppression'));

  if (hasSuppressedExperiment) return false;

  const hasExperiment = experiments?.some(experiment => experiment.includes('google-oauth') && experiment.includes('modal')) || false;
  // TODO: Have to roll back for now
  // const fansidedNetwork = BLUECONIC_SITES.includes(edition) && edition !== '229';
  // const properties = ['swimsuit.si.com', 'www.mentalfloss.com'];

  return hasExperiment;
};
